module.exports = "/_next/static/images/arrow_right_long-9678df628e779df5d3a4b621f96b525c.svg";